<template>
  <nav
    class="c-navigation"
    :style="{ width }"
    v-scroll
  >
    <slot />
  </nav>
</template>
<script>
export default {
  data () {
    return {
      width: 0
    }
  },
  mounted () {
    window.addEventListener('resize', this.setWidth)
    window.addEventListener('load', this.setWidth)
    this.setWidth()
  },
  destroyed () {
    window.removeEventListener('resize', this.setWidth)
    window.removeEventListener('load', this.setWidth)
  },
  methods: {
    setWidth () {
      const parentWidth = this.$el.parentNode.getBoundingClientRect().width
      this.width = parentWidth ? parentWidth + 'px' : '100%'
    }
  }
}
</script>

<style lang="scss">
@import '~@styles/convenia-components/reference.scss';

$c-navigation-border-color: #e9eaee !default;

.c-navigation {
  border-bottom: 1px solid $c-navigation-border-color;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/convenia-components/CNavigation.vue